import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
import Vue from 'vue';

var axios_instance_get = get_axios_instance(api_variables.SERVICE_NPS_GET);
var axios_instance_update = get_axios_instance(api_variables.SERVICE_NPS_POST);

const _pk_name = "id";

const state = {
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters={
    record: (state) => {
        return state.record
    }
}
const mutations={
        setFetching: (state, payload) => {
            state.isFetching = payload;
        },
        setRecord: (state, payload) => {
            state.record = payload.record;
        }
}
const actions={
    async fetchallFunction({commit},payload){
        try{
            commit("setFetching", true);
          let res = await axios_instance_get.get('/',{
            params:{
                employee_id:payload.employee_id
            }
          })
          commit("setFetching", false);
          if (res.status == 200) {
              commit("setRecord", [res.data.payload, payload]);
              //console.log("i am action new one", res)
          }
          return res;
        }
        catch(err){
         throw errorHandler(err.response)
        }
    },
    async updateNpsData({commit},payload){
        try{
            commit("setFetching",true);
            let res = await axios_instance_update.post('/',payload)
            commit("setFetching",false);
            if(res.status == 200){
                commit("setRecord",[res.data.payload,payload])
            }
            return res
          
        }
        catch(err){
          throw errorHandler(err.response)
        }
    }
}
export default{
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}